import { Box, Select, useColorModeValue as mode } from '@chakra-ui/react';
import { setStorage, STORAGE_KEY } from 'helpers/storage';
import { useTranslation } from 'react-i18next';
import { MdLanguage } from 'react-icons/md';
import { UserService } from 'services/user/user.service';
import { authInstance } from 'utils/auth';

const languages = [
  { code: 'en', lang: 'English' },
  { code: 'ja', lang: '日本語' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const trBackgroundColor = mode('grey.200', 'grey.500');
  const handleChangeLocale = async (lng: string) => {
    i18n.changeLanguage(lng);
    setStorage(STORAGE_KEY.I18_NEXT_LANGUAGE, lng);
    await UserService.changeLocale(lng);
    authInstance.forceRefreshToken();
  };

  return (
    <Box
      sx={{
        mr: '10px',
      }}
    >
      <Select
        sx={{
          cursor: 'pointer',
          fontWeight: 'bold',
          lineHeight: '1.1rem',
          borderRadius: 'md',
          transition: 'all 0.3s',
          '& > option': {
            color: { base: 'white', md: 'inherit' },
          },
          '& .chakra-select__wrapper': {
            width: { base: 'auto', md: 'auto' },
          },
          width: { base: '40px', md: 'auto' },
          paddingLeft: { base: '0', md: '10px' },
          color: { base: 'transparent', md: 'inherit' },
        }}
        icon={<MdLanguage />}
        iconSize='md'
        onChange={(e) => handleChangeLocale(e.target.value)}
        placeholder=''
        size={'md'}
        value={i18n.language}
      >
        {languages.map((item, index) => {
          return (
            <option
              key={`${item.code + index}`}
              style={{
                fontSize: '16px',
                fontWeight: 'normal',
                lineHeight: '1.1rem',
                borderRadius: 'md',
                transition: 'all 0.3s',
                backgroundColor: trBackgroundColor,
              }}
              value={item.code}
            >
              {item.lang}
            </option>
          );
        })}
      </Select>
    </Box>
  );
};

export default LanguageSelector;
